import { User } from 'core/models/user.model';
import { Store } from '../store.model';
import { UserState } from './user.model';

export class UserSelectors {
  static state = (store: Store): UserState => store.user;

  static data = (store: Store): User | null => store.user.data;
}
